import React from "react";
import { Box, IconButton } from "@mui/material";
import { Table } from "./components";
import { connect } from "react-redux";
import { changeCount } from "../../store/NotificationsStore";
import agent from "../../agent/agent";

const PER_PAGE = 15;

class Export extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      page: 1,
      totalCount: 0,
      totalPages: 1,
      isLoading: true,
      documentTypeNamesById: {},
    };
  }

  componentDidMount = async () => {
    this.props.changeCount({ key: 'export', value: 0 });
    await Promise.all([this.loadDocumentTypes(), this.getItems()]);
  }

  loadDocumentTypes = async () => {
    const items = await agent
      .get("/document-types")
      .then((res) => res?.data?.data || [])
      .catch(() => []);

    const documentTypeNamesById = {};
    items.forEach((item) => {
      const id = String(item?.id || "").trim();
      const name = String(item?.type || item?.name || "").trim();
      if (id && name) documentTypeNamesById[id] = name;
    });
    this.setState({ documentTypeNamesById });
  }

  getItems = async () => {
    await this.setState({ isLoading: true });
    const response = await agent.get(`/export/jobs?limit=${PER_PAGE}&page=${this.state.page}`)
      .then((res) => res).catch(() => null);

    const totalCount = Number.parseFloat(response?.headers?.['x-pagination-total-count'] || '0');
    const totalPages = Math.ceil(totalCount / PER_PAGE);

    this.setState({
      totalCount,
      totalPages,
      isLoading: false,
      items: response?.data?.data || [],
    });
  }

  changePage = async (page) => {
    await this.setState({ page });
    await this.getItems();
  }
  changeLimit = async (limit) => {
    await this.setState({ page: 1 });
    await this.getItems();
  }

  render() {
    const { page, items, isLoading, totalPages, totalCount, documentTypeNamesById } = this.state;

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 500, lineHeight: "28px", color: "#111111" }}>Результаты экспорта</h1>
          {totalCount > 0 && (
            <span style={{ fontSize: 12, fontWeight: 500, color: "#432DD7", backgroundColor: "#E0E7FF", borderRadius: 16, padding: "2px 8px" }}>
              {totalCount.toLocaleString("ru-RU")}
            </span>
          )}
          <IconButton onClick={this.getItems} size="small" sx={{ color: "#4F39F6" }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 3.125 13.5 3.125 13.5M3.125 13.5H6.25M3.125 13.5V17M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.8438 2.5 17.5 6.5 17.5 6.5M17.5 6.5V3M17.5 6.5H14.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </IconButton>
        </Box>

        <Table
          page={page}
          items={items}
          isLoading={isLoading}
          totalPages={totalPages}
          totalCount={totalCount}
          documentTypeNamesById={documentTypeNamesById}
          onChangePage={this.changePage}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications || { counts: {} },
});
const mapDispatchToProps = { changeCount };

export default connect(mapStateToProps, mapDispatchToProps)(Export)
